import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    loggedIn: false,
    afterLoginPath: '/home',
    requestItem: {},
    requestItems: [],
    userItem: {}
  },
  mutations: {
    setLoggedIn(state, payload) {
      state.loggedIn = payload;
    },
    setAfterLoginPath(state, payload) {
      state.afterLoginPath = payload;
    },
    setRequestItems(state, payload) {
      state.requestItems = payload;
    },
    setUserItem(state, payload) {
      state.userItem = payload;
    },
    setRequestItem(state, payload) {
      state.requestItem = payload;
    }
  },
  actions: {
    login({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/files/api/login.php', payload)
          .then(() => {
            commit('setLoggedIn', true);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    logout({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/files/api/logout.php', payload)
          .then(() => {
            commit('setLoggedIn', false);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAddress(_, postcode) {
      return new Promise((resolve, reject) => {
        axios.get('/files/api/postcode.php', { params: { postcode } })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setUpStripe({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/files/api/request.php?id=${payload}`)
          .then((res) => {
            commit('setRequestItem', res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getUserItem({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/files/api/user.php')
          .then((res) => {
            commit('setUserItem', res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    putUserItem(_, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/files/api/user.php', payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getRequestItems({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/files/api/request.php')
          .then((res) => {
            commit('setRequestItems', res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    postRequest(_, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/files/api/request.php', payload,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    putRequestState(_, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/files/api/request.php', payload).then(() => {
          resolve();
        })
          .catch((err) => {
            reject(err);
          });
      });
    },
    registration(_, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/files/api/registration.php', payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    unregistration({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/files/api/unregistration.php', payload)
          .then(() => {
            commit('setLoggedIn', false);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    stripe(_, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/files/api/stripe2024.php', payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    passwordResetSend(_, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/files/api/password-reset.php', payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    newPassword(_, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/files/api/new-password.php', payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkLoginId(_, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/files/api/check-login-id.php', payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkUpdateLoginId(_, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/files/api/check-update-login-id.php', payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
  modules: {
  },
});
